<div style="height: 550px; width: 600; overflow: hidden">
  <wfm-tabs
    style="height: 515px"
    [tabsMode]="tabsMode"
    [orientation]="tabsO"
    [hAlignment]="tabsHA"
    [vAlignment]="tabsVA"
    [removableTabs]="false"
    [(activeTabIndex)]="tabSelected"
    (activeTabIndexChange)="activeTabIndexChange()"
  >
    <wfm-tabs-item [label]="'vgl.tab_edit' | translate">
      <div class="flex flex--col flex--nowrap flex--stretch" style="height: 480px">
        <div class="flex-container-root flex--space-between flex--left">
          <ng-container *ngIf="!saveAsSelected && !renameSelected">
            <div style="display: flex; flex-direction: row; margin: 0; padding: 0; width: 65%">
              <label style="width: 38%; text-align: left; margin-top: 6px">
                {{ 'vgl.templates_templateSelectLabel' | translate }}</label
              >
              <wfm-select-dropdown
                [placeholder]="'vgl.templates_tabLabel' | translate"
                [required]="true"
                [items]="templates | orderBy: '+templateName'"
                labelField="templateName"
                [(value)]="selectedTemplate"
                iconField="icon"
                (valueChange)="templateSelectionChange()"
                style="min-width: 62%; margin-left: 1%; margin-right: 1%; text-overflow: ellipsis"
              >
              </wfm-select-dropdown>
            </div>

            <div
              style="
                display: flex;
                flex-direction: row;
                margin: 0;
                padding: 0;
                padding-left: 3%;
                padding-right: 3%;
                width: 40%;
              "
            >
              <label class="radio" style="margin-bottom: 0; margin-right: 4px" *ngFor="let item of templateTypeList">
                <input
                  class="radio__input"
                  type="radio"
                  [(ngModel)]="templateType"
                  name="list_name"
                  value="{{ item.value }}"
                  (change)="templateTypeChange(item)"
                />
                <span class="radio__label text-ellipsis" [tooltip]="item.name" [overflowOnly]="true">
                  {{ item.name }}
                </span>
              </label>

              <button
                *ngIf="showRename"
                style="padding-left: 1rem"
                type="button"
                class="button--no-border button button--tertiary"
                (click)="rename()"
              >
                <svg-icon
                  name="ico-edit-16"
                  class="button__icon button__icon--color"
                  [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                ></svg-icon>
                {{ 'vgl.rename' | translate }}
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="saveAsSelected || renameSelected">
            <label style="margin-top: 6px"> {{ 'vgl.templates_templateSelectLabel' | translate }} </label>
            <input
              class="textbox"
              [attr.aria-invalid]="isDuplicate"
              type="text"
              [(ngModel)]="saveAsName"
              [placeholder]="'vgl.templates_templateSelectPlaceHolder' | translate"
              [required]="true"
              (keyup)="checkDuplicateTemplateName()"
              style="width: 40%; padding-left: 2%"
            />

            <button type="button" class="button--no-border button button--tertiary u-ph---" (click)="saveAsCancel()">
              <svg-icon
                name="ico-arrow-left-16"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                class="button__icon button__icon--color"
              ></svg-icon>
              <span> {{ 'vgl.templates_saveAsCancelButton' | translate }} </span>
            </button>
            <button
              [disabled]="saveAsName && saveAsName.length < 3 || isDuplicate"
              type="button"
              class="button--no-border button button--tertiary u-ph---"
              (click)="saveAsSave()"
            >
              <svg-icon
                name="ico-save-16"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                class="button__icon button__icon--color"
              ></svg-icon>
              <span>{{ 'vgl.templates_saveButton' | translate }}</span>
            </button>
          </ng-container>
        </div>

        <div>
          <div
            class="relative flex-middle flex--row"
            role="alert"
            #errormsg
            id="layoutcountMsg"
            style="min-height: 20px; margin-left: 23%"
          >
            <div *ngIf="layoutCountMessage">
              <svg-icon
                name="ico-form-error-16"
                [svgStyle]="{ 'width.px': 16, 'height.px': 10, 'margin-right.px': 7, fill: '#df4661' }"
              >
              </svg-icon>
              {{ layoutCountMessage }}
            </div>
          </div>
          <div class="relative flex flex--row">
            <div style="width: 50%; padding-bottom: 0.5rem">
              <div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
                <input
                  class="textbox u-p--- input-with-icon"
                  type="text"
                  id="filterHidden"
                  [(ngModel)]="searchStr"
                  placeholder="{{ filterBy }}"
                />
                <div class="filter__icon filter__icon--no-event" *ngIf="!searchStr">
                  <!-- ico-filter-16.svg -->
                  <svg-icon
                    style="height: 1.6rem"
                    name="ico-filter-16"
                    [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                  >
                  </svg-icon>
                </div>
                <div class="filter__icon" *ngIf="searchStr" (click)="removeFilter()">
                  <!-- ico-close-12.svg -->
                  <svg-icon
                    name="ico-close-16"
                    [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                  ></svg-icon>
                </div>
              </div>
            </div>
            <div
              role="alert"
              #errormsg
              id="layouterrorMsg"
              *ngIf="layoutErrorMessage"
              style="position: relative; width: 50%; padding-left: 0.8rem"
            >
              <svg-icon
                name="ico-form-error-16"
                [svgStyle]="{ 'width.px': 16, 'height.px': 10, 'margin-right.px': 7, fill: '#df4661' }"
              >
              </svg-icon>
              {{ layoutErrorMessage }}
            </div>
          </div>
        </div>
        <div
          class="
            relative
            flex--item--zero flex flex--row flex--stretch flex--nowrap
            virtual-grid-layout-swap-list
            cdkDropListGroup
          "
        >
          <div
            class="flex--item--zero flex flex--col u-mr---"
            id="hiddenDropList"
            #hiddenList="cdkDropList"
            cdkDropList
            [cdkDropListConnectedTo]="shownList"
            [cdkDropListData]="hiddenWorklistColumnData | search: searchStr:'headerLabel'"
            (cdkDropListDropped)="drop($event)"
          >
            <span
              >{{ 'vgl.templates_columnsHiddenLabel' | translate }} ({{
                (hiddenWorklistColumnData | search: searchStr:'headerLabel').length
              }})</span
            >
            <div class="flex--item--zero u-ml---" style="overflow-x: hidden" wfmScrollbar>
              <ng-container *ngFor="let checkItem of hiddenWorklistColumnData | search: searchStr:'headerLabel'">
                <label class="flex-container-panel background u-mh0" cdkDrag>
                  <svg-icon name="ico-grab-move-panel-vertical-16" class="icon_fill"></svg-icon>
                  <div style="width: 80%">
                    <span class="columnName" [overflowOnly]="true" [tooltip]="checkItem.headerLabel"
                      >{{ checkItem.headerLabel }}
                    </span>
                  </div>
                  <svg-icon
                    name="ico-add-16"
                    style="margin-right: 6px"
                    class="icon_fill"
                    (click)="addColumn(checkItem)"
                  ></svg-icon>
                </label>
              </ng-container>
              <div ngClass="absolute overlay" *ngIf="templateType === 'Common' && !admin"></div>
            </div>
          </div>

          <div
            class="flex--item--zero flex flex--col u-ml---"
            cdkDropList
            id="shownDropList"
            #shownList="cdkDropList"
            [cdkDropListConnectedTo]="hiddenList"
            [cdkDropListData]="shownWorklistColumnData"
            (cdkDropListDropped)="dropShown($event)"
          >
            <span>{{ 'vgl.templates_columnsShownLabel' | translate }} ( {{ shownWorklistColumnData.length }})</span>
            <div class="flex--item--zero" wfmScrollbar style="overflow-x: hidden">
              <ng-container *ngFor="let checkItem of shownWorklistColumnData">
                <label class="flex-container-panel background u-mh0" cdkDrag>
                  <svg-icon name="ico-grab-move-panel-vertical-16" class="icon_fill"></svg-icon>
                  <div style="width: 80%">
                    <span class="columnName" [overflowOnly]="true" [tooltip]="checkItem.headerLabel">{{
                      checkItem.headerLabel
                    }}</span>
                  </div>
                  <svg-icon
                    name="ico-remove-16"
                    style="margin-right: 6px"
                    class="icon_fill"
                    (click)="removeColumn(checkItem)"
                  ></svg-icon>
                </label>
              </ng-container>
              <div ngClass="absolute overlay" *ngIf="templateType === 'Common' && !admin"></div>
            </div>
          </div>
        </div>

        <div class="flex flex--row flex--nowrap flex--top flex--right u-mv-">
          <button
            *ngIf="!admin && selectedTemplate.isGlobalTemplate && showReset"
            type="button"
            class="button--no-border button button--tertiary flex__item u--1/3"
            (click)="reset()"
          >
            <svg-icon
              name="ico-reset-16"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
              class="button__icon button__icon--color"
            ></svg-icon>
            <span class="text-ellipsis" [overflowOnly]="true" [tooltip]="'vgl.resetToCommon' | translate">{{
              'vgl.resetToCommon' | translate
            }}</span>
          </button>
          <div class="flex flex--row flex--nowrap flex--right flex--top u--1/2">
            <button
              type="button"
              class="button button--tertiary u--1/2 flex--center"
              aria-pressed="false"
              (click)="saveAs()"
              [disabled]="!showSaveAs"
            >
              <span
                class="text-ellipsis"
                [overflowOnly]="true"
                [tooltip]="'vgl.templates_saveAsSaveButton' | translate"
                >{{ 'vgl.templates_saveAsSaveButton' | translate }}</span
              >
            </button>
            <button
              type="button"
              class="button u-ml-- u--1/2 flex--center"
              aria-pressed="false"
              [disabled]="isDuplicate || !isLayoutChanged"
              (click)="saveColumns()"
            >
              <span class="text-ellipsis" [overflowOnly]="true" [tooltip]="'vgl.templates_saveButton' | translate"
                >{{ 'vgl.templates_saveButton' | translate }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </wfm-tabs-item>

    <wfm-tabs-item [label]="'vgl.tab_applyToWorklists' | translate">
      <div class="flex-container-root" style="justify-content: space-between; align-items: center; height: 4rem">
        <ng-container *ngIf="!anySelected">
          <div style="font-size: 1.6rem; font-style: italic">
            {{ 'vgl.worklists_templateSelectMsg' | translate }}
          </div>
        </ng-container>
        <ng-container *ngIf="anySelected">
          {{ selectedWorklists }} selected
          <wfm-select-dropdown
            placeholder="Select Template"
            labelField="templateName"
            [required]="true"
            [items]="templates | orderBy: '+templateName'"
            [(value)]="selectedTemplate"
            (valueChange)="templateSelectionChange()"
            iconField="icon"
            style="width: 60%"
          ></wfm-select-dropdown>
          <button type="button" class="button" aria-pressed="false" (click)="applyTemplate()">
            {{ 'vgl.worklists_templateApplyButtonLabel' | translate }}
          </button>
        </ng-container>
      </div>

      <div class="flex-container-root virtual-grid-container virtual-grid--stripped">
        <div
          wfmScrollbar
          style="
            justify-content: unset;
            height: 400px;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            margin: 0%;
            padding: 0%;
          "
        >
          <div class="virtual-grid-header" style="margin: 0; padding: 0" #innerWorkListHeader>
            <div class="virtual-grid-header-row">
              <div class="checkbox-select virtual-grid-cell virtual-grid-header-cell" style="padding: 3px 5px">
                <label class="flex-container-panel-worklist checkbox" style="padding: 0px">
                  <input
                    type="checkbox"
                    class="checkbox__input"
                    [(ngModel)]="masterSelected"
                    name="masterSelected"
                    value="m1"
                    (change)="checkUncheckAll()"
                    style="margin: 5px"
                  />
                  <span class="checkbox__label"> </span>
                  <div>{{ 'vgl.worklists_worklistColumnHeader' | translate }}</div>

                  <div>{{ 'vgl.worklists_templateColumnHeader' | translate }}</div>
                </label>
              </div>
            </div>
          </div>

          <wfm-accordion
            caretsAlignment="left"
            [multiple]="true"
            (selectionChange)="accordionSelectionChange($event)"
          >
            <wfm-accordion-item
              *ngIf="!admin"
              [filled]="true"
              selected="true"
              [label]="'vgl.worklists_myWorklistGroupHeader' | translate"
              (selectedChange)="accordionItemSelectionChange($event)"
            >
              <ng-container
                *ngFor="
                  let worklist of managementWorklists | filter: 'Custom':'worklistType' | sort: 'asc':'worklistName';
                  index as rowIndex;
                  odd as odd
                "
              >
                <div class="virtual-grid-row" id="worklist-item-{{ rowIndex }}" #row [class.odd]="odd">
                  <div class="checkbox-select virtual-grid-cell" style="padding: 3px 5px">
                    <label class="flex-container-panel-worklist checkbox" style="padding: 0px">
                      <input
                        type="checkbox"
                        class="checkbox__input"
                        [(ngModel)]="worklist.isSelected"
                        (change)="isAllSelected(); isAnySelected()"
                        style="margin-right: 5px"
                      />
                      <span class="checkbox__label"> </span>
                      <div>
                        {{ worklist.worklistName }}
                      </div>
                      <div *ngIf="admin">
                        <svg-icon
                          name="ico-user-16"
                          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                        ></svg-icon>
                        {{ worklist.defaultTemplate[1] }}
                      </div>
                      <div *ngIf="!admin">
                        <div *ngIf="worklist.hasUserLayout">
                          <svg-icon
                            name="ico-user-16"
                            [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                          ></svg-icon>
                          {{ worklist.currentTemplate[1] }}
                        </div>
                        <div *ngIf="!worklist.hasUserLayout">
                          <svg-icon
                            name="ico-group-16"
                            [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                          ></svg-icon>
                          {{ worklist.defaultTemplate[1] }}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </ng-container>
            </wfm-accordion-item>

            <wfm-accordion-item
              [filled]="true"
              selected="true"
              [label]="'vgl.worklists_systemWorklistGroupHeader' | translate"
              (selectedChange)="accordionItemSelectionChange($event)"
            >
              <ng-container
                *ngFor="
                  let worklist of managementWorklists | filter: 'System':'worklistType' | sort: 'asc':'worklistName';
                  index as rowIndex;
                  odd as odd
                "
              >
                <div class="virtual-grid-row" id="worklist-item-{{ rowIndex }}" #row [class.odd]="odd">
                  <div class="checkbox-select virtual-grid-cell" style="padding: 3px 5px">
                    <label class="flex-container-panel-worklist checkbox" style="padding: 0px">
                      <input
                        type="checkbox"
                        class="checkbox__input"
                        [(ngModel)]="worklist.isSelected"
                        (change)="isAllSelected(); isAnySelected()"
                        style="margin-right: 5px"
                      />
                      <span class="checkbox__label"> </span>
                      <div>
                        {{ worklist.worklistName }}
                      </div>
                      <div *ngIf="admin">
                        <svg-icon
                          name="ico-group-16"
                          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                        ></svg-icon>
                        {{ worklist.defaultTemplate[1] }}
                      </div>
                      <div *ngIf="!admin">
                        <div *ngIf="worklist.hasUserLayout">
                          <svg-icon
                            name="ico-user-16"
                            [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                          ></svg-icon>
                          {{ worklist.currentTemplate[1] }}
                        </div>
                        <div *ngIf="!worklist.hasUserLayout">
                          <svg-icon
                            name="ico-group-16"
                            [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                          ></svg-icon>
                          {{ worklist.defaultTemplate[1] }}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </ng-container>
            </wfm-accordion-item>

            <wfm-accordion-item
            *ngIf="!admin"
            [filled]="true"
            selected="true"
            [label]="'vgl.worklists_foldersGroupHeader' | translate"
            (selectedChange)="accordionItemSelectionChange($event)"
          >
            <ng-container
              *ngFor="
                let worklist of managementWorklists | filter: 'Folders':'worklistType' | sort: 'asc':'worklistName';
                index as rowIndex;
                odd as odd
              "
            >
              <div class="virtual-grid-row" id="worklist-item-{{ rowIndex }}" #row [class.odd]="odd">
                <div class="checkbox-select virtual-grid-cell" style="padding: 3px 5px">
                  <label class="flex-container-panel-worklist checkbox" style="padding: 0px">
                    <input
                      type="checkbox"
                      class="checkbox__input"
                      [(ngModel)]="worklist.isSelected"
                      (change)="isAllSelected(); isAnySelected()"
                      style="margin-right: 5px"
                    />
                    <span class="checkbox__label"> </span>
                    <div>
                      {{ worklist.worklistName }}
                    </div>
                    <div *ngIf="admin">
                      <svg-icon
                        name="ico-user-16"
                        [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                      ></svg-icon>
                      {{ worklist.defaultTemplate[1] }}
                    </div>
                    <div *ngIf="!admin">
                      <div *ngIf="worklist.hasUserLayout">
                        <svg-icon
                          name="ico-user-16"
                          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                        ></svg-icon>
                        {{ worklist.currentTemplate[1] }}
                      </div>
                      <div *ngIf="!worklist.hasUserLayout">
                        <svg-icon
                          name="ico-group-16"
                          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
                        ></svg-icon>
                        {{ worklist.defaultTemplate[1] }}
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </ng-container>
          </wfm-accordion-item>
          </wfm-accordion>
        </div>
      </div>
    </wfm-tabs-item>
  </wfm-tabs>
</div>
